import { jsx as _jsx } from 'react/jsx-runtime';
export const IconFioriSysEnter = (props) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm14.707-3.707a1 1 0 0 0-1.414 0L10 13.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0 0-1.414Z',
      fill: 'currentColor',
    }),
  });
IconFioriSysEnter.displayName = 'IconFioriSysEnter';
